import { FormGroup } from '@angular/forms';
import { DestroyRef } from '@angular/core';
import { Observable, distinctUntilChanged } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { withoutViewport } from './search-request';

/** Drafts belong to the mode; executed query/results are never edited by the form. */
export function bindSearchModeForm<S extends {query?: object; mapQuery?: object; listDraft?: object; mapDraft?: object; searchRestoreRevision?: number}>(
  form: FormGroup, states: Observable<S>, isMap: (state: S) => boolean,
  save: (draft: any) => void, destroy: DestroyRef
): void {
  const defaults = structuredClone(withoutViewport(form.getRawValue()));
  states.pipe(distinctUntilChanged((a,b) => isMap(a) === isMap(b) && a.searchRestoreRevision === b.searchRestoreRevision), takeUntilDestroyed(destroy)).subscribe(state => {
    const draft = isMap(state) ? state.mapDraft ?? state.mapQuery ?? state.listDraft ?? state.query : state.listDraft ?? state.query;
    const value = {...defaults, ...structuredClone(withoutViewport(draft ?? {}))};
    form.reset(value, {emitEvent: true});
    save(form.getRawValue());
  });
  form.valueChanges.pipe(takeUntilDestroyed(destroy)).subscribe(() => save(form.getRawValue()));
}
